import { HotmartRum } from '@commons/observability'

class ScriptLoadError extends Error {
  scriptSrc: string;

  constructor(scriptSrc: string) {
      super(`Falha ao carregar o script: ${scriptSrc}`);
      this.name = 'ScriptLoadError';
      this.scriptSrc = scriptSrc;
      if (Error.captureStackTrace) {
          Error.captureStackTrace(this, this.constructor);
      }
  }
}

window.addEventListener('error', (event: ErrorEvent) => {
  const element = event.target as HTMLElement;

  if (element instanceof HTMLScriptElement) {
    HotmartRum.captureException(new ScriptLoadError(element.src));
  }
}, true);